<template>
  <contest-prizes :prizes="prizes" :center="center"><slot/></contest-prizes>
</template>

<script>
import ContestPrizes from '@/containers/ContestPrizes/ContestPrizes'

export default {
  components: {
    ContestPrizes
  },
  props: {
    center: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      prizes: [
        '/img/contest/prize-1.png',
        '/img/contest/prize-2.png',
        '/img/contest/prize-3.png'
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/ContestPrizes/ContestPrizesContainer.vue